<script setup lang="ts">
const props = defineProps<{
	color: 'green' | 'yellow' | 'blue' | 'purple' | 'lime' | 'red' | 'sapphire' | 'bronze' | 'silver' | 'gold' | 'platinum'
}>()

let bgColor
let textColor

switch (props.color) {
	case 'green':
		bgColor = 'bg-green-100'
		textColor = 'text-green-600'
		break
	case 'blue':
		bgColor = 'bg-[#dbeafe]'
		textColor = 'text-[#2563eb]'
		break
	case 'yellow':
		bgColor = 'bg-[#fef9c3]'
		textColor = 'text-[#ca8a04]'
		break
	case 'purple':
		bgColor = 'bg-[#f3ebff]'
		textColor = 'text-[#9333ea]'
		break
	case 'lime':
		bgColor = 'bg-[#ecfccb]'
		textColor = 'text-[#65a30d]'
		break
	case 'red':
		bgColor = 'bg-[#fee2e2]'
		textColor = 'text-[#e53e3e]'
		break
	case 'sapphire':
		bgColor = 'bg-sapphire-100'
		textColor = 'text-sapphire-600'
		break
	case 'bronze':
		bgColor = 'bg-bronze-100'
		textColor = 'text-bronze-600'
		break
	case 'silver':
		bgColor = 'bg-silver-100'
		textColor = 'text-silver-600'
		break
	case 'gold':
		bgColor = 'bg-gold-100'
		textColor = 'text-gold-600'
		break
	case 'platinum':
		bgColor = 'bg-platinum-100'
		textColor = 'text-platinum-600'
		break
	default:
		bgColor = 'bg-green-100'
		textColor = 'bg-green-600'
		break
}

</script>

<template>
	<span :class="['inline-flex items-center rounded-md px-2 py-1 text-xs font-medium', bgColor,  textColor]">
		<slot />
	</span>
</template>
